let matrixInstance: MatrixInstance;

function __getInstance__(): MatrixInstance {
    return matrixInstance;
}

function __setInstance__(instance: MatrixInstance): void {
    matrixInstance = instance;
}

export {
    __getInstance__,
    __setInstance__
};
